import { api } from '../api';

export const AgeCheckApi = {
  pass: async () => {
    await api.post('/age-check/pass');
  },
};
